import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PartnerStateService } from '../../modules/partner/services/partner-state.service';

@Component({
  selector: 'app-page-registration',
  templateUrl: './page-registration.component.html',
  styleUrls: ['./page-registration.component.css']
})
export class PageRegistrationComponent implements OnInit {

  @ViewChild('partnerRegistrationForm', {static: true}) partnerRegistrationForm;

  constructor(
    private router: Router,
    private partnerStateService: PartnerStateService,
  ) { }

  ngOnInit() {
    this.partnerRegistrationForm.showPassword = true;
  }

  onBack() {
    this.router.navigate(['']);
  }

  onRegister() {
    this.partnerStateService.createPartner(
      this.partnerRegistrationForm.partner,
      this.partnerRegistrationForm.password.password
    ).subscribe(
      result => {
        if (result) {
          this.router.navigate(['thank_you']);
        } else {
          this.partnerRegistrationForm.error = 'Registration failed. Please try again later';
        }
      },
      (error) => {
        this.partnerRegistrationForm.error = error.message;
      }
    );
  }

  onLogin() {
    this.router.navigateByUrl('/login');
  }

}
